import useStore from "./_store"
import { useState, useEffect, useRef } from "react"
import defaultAvatar from "@resources/scss/images/default-avatar.png"

export default ({ user }) => {
	// store
	const totalRO = useStore(state => state.totalRO)
	const unassignedRO = useStore(state => state.unassignedRO)
	const setUnassignedRO = useStore(state => state.setUnassignedRO)
	const addSelectedHuntUser = useStore(state => state.addSelectedHuntUser)

	//state
	const [count, setCount] = useState(user.hunt_count ? user.hunt_count : 0)
	const { id, first_name, last_name, user_name, email, avatar } = user


	const handleInputChange = (e) => {
		// get rid of non-numbers
		e.target.value = e.target.value.replace(/[^0-9]/g, '')

		// get rid of leading zeros unless its 0
		if (e.target.value.length > 1 && e.target.value[0] == 0) {
			e.target.value = e.target.value.slice(1)
		}

		// if empty, set to 0
		if (e.target.value == '') {
			e.target.value = 0
		}

		// dont allow more than unassigned
		if (Number(e.target.value) > unassignedRO + count) {
			e.target.value = unassignedRO + count
		}

		handleStateChange(Number(e.target.value))
	}

	const handleStateChange = (number) => {
		let difference = number - count
		setUnassignedRO(unassignedRO - difference)
		setCount(number)
	}

	const handleIncrement = (e) => {
		if (unassignedRO == 0) return

		handleStateChange(count + 1)
	}

	const handleDecrement = (e) => {
		if (count == 0) return

		handleStateChange(count - 1)
	}

	useEffect(() => {
		const parsedUser = {
			id,
			quantity: count
		}

		addSelectedHuntUser(parsedUser)
	}, [count])

	return (
		<div className="p-2 py-4 flex items-center gap-4" data-id={id}>
			{/* checkbox and img */}
			<input type="checkbox" checked={
				count == 0 ? false : true
			}

				onChange={(e) => {
					if (count == 0) {
						handleStateChange(1)
					} else {
						handleStateChange(0)
					}
				}}

			/>
			<img src={avatar ? avatar : defaultAvatar} className="w-[60px] h-[60px] rounded-full bg-grey aspect-square" />
			{/* Information */}
			<div className="flex flex-col  gap-4  grow ">
				<h2 className="flex flex-col text-base font-bold">
					{first_name} {last_name}
					<span className="text-sm font-normal">
						{email}
					</span>
				</h2>

				<div>
					<p className="text-sm">
						Assigned {count} of {totalRO} links
					</p>

					{/* progressbar */}
					<div className="relative bg-grey rounded-full h-2">
						<div className="absolute bg-primary rounded-full h-full transition-all" style={{ width: `${(count / totalRO) * 100}%` }}></div>
					</div>
				</div>

			</div>

			{/* Counter */}
			<div className="flex items-center gap-1">
				<button className="btn min-h-[30px] p-0 aspect-square"
					onClick={handleDecrement}
				>
					<span className="text-xl font-MaterialIcons">Remove</span>
				</button>
				<input className="w-12 text-center border-grey rounded-primary border-thin p-1"
					value={count}
					onChange={handleInputChange}
				/>
				<button className="btn min-h-[30px] p-0 aspect-square"
					onClick={handleIncrement}
				>
					<span className="text-xl font-MaterialIcons">Add</span>
				</button>
			</div>
		</div>
	)
}
